import {updateField} from "vuex-map-fields"
import {getDefaultState} from "./level1State"

export default {
	updateField,
	RESET_STATE(state) {
		Object.assign(state, getDefaultState())
	},
	SET_LEVELS_1(state, payload) {
		state.levels = payload
	},
	SET_LEVEL_1(state, payload) {
		state.level = payload
	},
	SET_VALIDATION_ERRORS(state, payload) {
		for (const key in payload) {
			state.validation_level_1[key] = '* '+payload[key][0]
		}
	},
	CLEAR_VALIDATION(state) {
		for (const key in state.validation_level_1) {
			state.validation_level_1[key] = null
		}
	},
}
